import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/collection/$collectionId/_layout/",
)({
  loader: async ({ params, parentMatchPromise }) => {
    const parentMatch = await parentMatchPromise
    if (parentMatch.fullPath === "/procurement/supply-plan/collection/$collectionId") {
      throw redirect({
        to: "/procurement/supply-plan/collection/$collectionId/overview",
        params,
        search: parentMatch.search,
      })
    }
    return null
  },
})
